import React, {useState} from 'react';
import Lightbox from "react-awesome-lightbox";
// You need to import the CSS only once
import "react-awesome-lightbox/build/style.css";
import {useSetRecoilState} from 'recoil';
import {isZoomingImage} from '../../../../../states/states';

const ImageWrapper = ({question}) => {
    const [showLightBox, setShowLightBox] = useState(false);
    const setIsZoomingImage = useSetRecoilState(isZoomingImage);

    const zoomImage = () => {
        setShowLightBox(true);
        setIsZoomingImage(true);
    };

    const closeZoomImage = () => {
        setShowLightBox(false);
        setIsZoomingImage(false);
    };

    if (question.hasImage) {
        let urlImage = `${process.env.REACT_APP_CMS_BASE_URL}/${question.hasImage}`;
        if (urlImage.replace('http', '').search('http') !== -1) {
            urlImage = question.hasImage;
        }
        return (
            <div className="list-test zoom-image" style={{marginTop: '20px'}}>
                <img src={urlImage} alt="Test" className="center" onClick={zoomImage}/>
                {showLightBox ? <Lightbox image={urlImage} onClose={closeZoomImage}/> : <></>}
            </div>
        )
    }
    return <></>;
};

export default ImageWrapper;